import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivityClimbingComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m8 3 4 8 5-5 5 15H2L8 3z" fill="none" />
      </svg>
    </SvgIcon>
  );
};
IconActivityClimbingComponent.displayName = 'IconActivityAlpaca';

const IconActivityClimbing = React.memo(IconActivityClimbingComponent);

export default IconActivityClimbing;
